import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { useFetchCLByPrescription } from '../../../../hooks/use-fetch-cl-by-prescription.js';

const DummyAddToCartCTA = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { actions , state , selectors , triggerToastMessage  } = useCLEcommContext();
    const { queries , configurations  } = state;
    const { left , right  } = queries;
    const fetchLeftCL = useFetchCLByPrescription({
        eyeSide: 'left'
    });
    const fetchRightCL = useFetchCLByPrescription({
        eyeSide: 'right'
    });
    const hasLeftRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, 'left');
    const hasRightRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, 'right');
    const hasRecoverableError = selectors.hasRecoverableError(state);
    const hasNonrecoverableError = selectors.hasNonrecoverableError(state);
    const triggerValidations = React.useCallback(()=>{
        // Form validation errors
        if (!hasNonrecoverableError) {
            actions.triggerValidationErrors();
        }
        // Query errors: non-recoverable
        if (hasNonrecoverableError) {
            triggerToastMessage('non-recoverable-error');
        }
        // Query errors: recoverable
        if (hasRecoverableError && !hasNonrecoverableError) {
            triggerToastMessage('recoverable-error');
        }
        // Query errors: recoverable
        // if there was a recoverable error when fetching the SKU by prescription, try the query again
        hasLeftRecoverableError && fetchLeftCL(configurations.left.prescription);
        hasRightRecoverableError && fetchRightCL(configurations.right.prescription);
    }, [
        actions,
        left,
        right,
        configurations,
        hasNonrecoverableError,
        hasRecoverableError
    ]);
    return /*#__PURE__*/ React.createElement(Button, {
        className: className,
        "data-t": "btn-enter-prescription",
        caption: getLabel('products.actions.addToCart'),
        onClick: triggerValidations,
        isLoading: left.loading || right.loading
    });
};

export { DummyAddToCartCTA };
//# sourceMappingURL=DummyAddToCartCTA.js.map
